// ---------------------------------------------------------------------------
// KunjVeda - Master Products Data (Single Source of Truth)
// Used by ProductItem.jsx, ProductDetail.jsx, and Shop pages
// ---------------------------------------------------------------------------

// Spices folder images
import turmeric2 from "../images/spices/turmeric2.jpg";
import turmeric1 from "../images/spices/turmeric.jpg";
import redChilliPowderSpices from "../images/spices/redChilliPowder.jpg";
import redChilli2Spices from "../images/spices/redcilliPowder2.jpg";
import corianderSpices from "../images/spices/coriander.jpg";
import corianderPowderSpices from "../images/spices/corianderPowder.jpg";
import reCoriander from "../images/spices/re-coriander.png";
import bgCumin from "../images/spices/bgcuminPowder.png";
import cuminPowder from "../images/spices/cuminPowder.jpg";
import blackPepper1 from "../images/spices/blackPepper.jpg";
import blackPepper2 from "../images/spices/blackPepper2.jpg";
import blackPepper3 from "../images/spices/blackPepper3.jpg";
import garamMasalaImg from "../images/spices/garamMasala.jpg";
import greenCardamomImg from "../images/spices/greenCardamom.jpg";
import cinnamonSticksImg from "../images/spices/cinnamonSticks.jpg";
import mustardImg from "../images/spices/mustard.jpg";
import fennelSeedsImg from "../images/spices/fennelSeeds.jpg";
import clovesWebp from "../images/spices/cloves.webp";
import clovesJpg from "../images/spices/cloves.jpg";
import clovesRe from "../images/spices/cloves-re.jpg";
import moringaPowderImg from "../images/spices/Moringa-Leaves-Powder-1.webp";
import spicesAssorted1 from "../images/spices/spices.jpg";
import spicesAssorted2 from "../images/spices/spices2.jpg";
import spicesAssorted3 from "../images/spices/spices3.jpg";

// ProductList folder images
import spiceTurmericPowder from "../images/productList/turmericPowder.png";
import spiceRedChilliPowder from "../images/productList/redChilliPowder.png";
import redChilliWholePng from "../images/productList/red chilli.png";
import redChilliWhole2Png from "../images/productList/red chilli 2.png";
import spiceCorianderPowder from "../images/productList/corianderPowder.png";
import groupImagePng from "../images/productList/group image.png";
import spiceMoringaPowder from "../images/productList/moringaPowder.png";
import spiceAmlaPowder from "../images/productList/amlaPowder.png";
import spiceAmchoorPowder from "../images/productList/amchoor.png";
import amchoorPowder from "../images/productList/amchoor2.png";
import amlaPowder from "../images/productList/amla2.png";
import moringaPowder from "../images/productList/moringa2.png";

export const products = [
    {
        id: 1,
        slug: "turmeric-powder",
        name: "Turmeric Powder",
        category: "Powdered Spices",
        weight: "100 g",
        image: spiceTurmericPowder,
        images: [spiceTurmericPowder, turmeric2, turmeric1, spicesAssorted1],
        price: 45,
        oldPrice: 60,
        rating: 4.5,
        reviews: 149,
        badge: "Sale",
        inStock: true,
        tagline: "High Curcumin (5%+) | Stone-Ground | Sun-Dried In Kerala Farms",
        weights: [
            { weight: "100 g", price: 45, oldPrice: 60, discount: "25% OFF" },
            { weight: "250 g", price: 75, oldPrice: 95, discount: "21% OFF" },
            { weight: "500 g", price: 120, oldPrice: 150, discount: "20% OFF", popular: true },
            { weight: "1 kg", price: 230, oldPrice: 290, discount: "21% OFF" },
        ],
        description:
            "KunjVeda Pure Salem Turmeric Powder is ground from selectively chosen Salem turmeric fingers cultivated under natural sunlight. Rich in natural bioactive curcumin (5%+), its vibrant golden-yellow hue, warm peppery aroma, and medicinal potency make it a culinary and Ayurvedic treasure for your kitchen.",
        origin: "Salem & Erode, Tamil Nadu, India",
        shelfLife: "12 Months from packaging",
        dietary: "100% Pure Vegetarian | Non-GMO | Gluten-Free",
        features: [
            { title: "High Curcumin Content", desc: "Contains 5%+ natural curcumin without chemical extraction." },
            { title: "Cold Stone-Ground", desc: "Slow stone grinding preserves fragile aromatic volatile oils." },
            { title: "Zero Lead Chromate", desc: "100% natural color, certified zero artificial colorants or fillers." },
            { title: "Traditional Heritage", desc: "Steam sterilized and packaged in food-grade multi-layer pouches." },
        ],
        ayurvedicBenefits: [
            "Potent natural anti-inflammatory & antioxidant agent.",
            "Supports daily immunity, joint flexibility, and skin radiance.",
            "Traditional staple for Golden Milk (Haldi Doodh) and healing tonics.",
            "Assists healthy metabolic digestion and gentle detoxification.",
        ],
        nutrition: {
            energy: "354 kcal",
            carbohydrates: "64.9 g",
            protein: "7.8 g",
            fat: "9.9 g",
            activeCompound: "Curcumin (5.2%)",
        },
    },
    {
        id: 2,
        slug: "red-chilli-powder",
        name: "Red Chilli Powder",
        category: "Powdered Spices",
        weight: "100 g",
        image: spiceRedChilliPowder,
        images: [spiceRedChilliPowder, redChilliWholePng, redChilli2Spices, redChilliWhole2Png],
        price: 55,
        oldPrice: 75,
        rating: 4.5,
        reviews: 98,
        badge: "Hot",
        inStock: true,
        tagline: "Rich Deep Red Color | Mildly Fiery | Stone Ground with Stems Removed",
        weights: [
            { weight: "100 g", price: 55, oldPrice: 75, discount: "27% OFF" },
            { weight: "250 g", price: 100, oldPrice: 130, discount: "23% OFF" },
            { weight: "500 g", price: 180, oldPrice: 220, discount: "18% OFF", popular: true },
            { weight: "1 kg", price: 340, oldPrice: 420, discount: "19% OFF" },
        ],
        description:
            "Handpicked from the sunny farms of Guntur, Andhra Pradesh, KunjVeda Red Chilli Powder delivers an exquisite balance of fiery heat and stunning natural crimson color. Made from sun-dried chillies with stems carefully removed, then gently pulverized to preserve capsaicin and essential oils.",
        origin: "Guntur, Andhra Pradesh, India",
        shelfLife: "12 Months from packaging",
        dietary: "100% Pure Vegetarian | No Sudan Dyes | Preservative-Free",
        features: [
            { title: "Stemless Chillies", desc: "Only high-grade sun-dried chilli pods are chosen; stems are hand-sorted out." },
            { title: "Natural Crimson Hue", desc: "High natural ASTA color value gives your curries a luscious red look." },
            { title: "No Added Flavors", desc: "Pure heat and authentic pungent aroma with zero synthetic additives." },
            { title: "Lab Tested Batch", desc: "Aflatoxin tested and certified free of artificial food dyes." },
        ],
        ayurvedicBenefits: [
            "Stimulates gastric enzymes and kindles digestive fire (Jatharagni).",
            "Capsaicin aids healthy circulation and metabolic expenditure.",
            "Natural source of Vitamin C and carotenoid antioxidants.",
            "Clears seasonal congestion and revives sluggish appetite.",
        ],
        nutrition: {
            energy: "318 kcal",
            carbohydrates: "56.6 g",
            protein: "12.0 g",
            fat: "17.3 g",
            activeCompound: "Capsaicin (High Pungency)",
        },
    },
    {
        id: 3,
        slug: "coriander-powder",
        name: "Coriander Powder",
        category: "Powdered Spices",
        weight: "100 g",
        image: spiceCorianderPowder,
        images: [spiceCorianderPowder, reCoriander, corianderPowderSpices, corianderSpices],
        price: 40,
        oldPrice: 45,
        rating: 4.0,
        reviews: 54,
        badge: "",
        inStock: true,
        tagline: "Fresh Green Seeds | Sweet Citrus Aroma | Low-Temperature Ground",
        weights: [
            { weight: "100 g", price: 40, oldPrice: 45, discount: "22% OFF" },
            { weight: "250 g", price: 65, oldPrice: 85, discount: "24% OFF" },
            { weight: "500 g", price: 110, oldPrice: 140, discount: "21% OFF", popular: true },
            { weight: "1 kg", price: 210, oldPrice: 270, discount: "22% OFF" },
        ],
        description:
            "Sourced from Rajasthan's prime coriander belts, KunjVeda Coriander Powder is ground from fragrant, olive-green coriander seeds. It imparts an earthy, soothing sweetness and refreshing herbal undertone, giving full-bodied gravy texture and authentic depth to curries and dals.",
        origin: "Kota & Ramganj Mandi, Rajasthan, India",
        shelfLife: "12 Months from packaging",
        dietary: "100% Pure Vegetarian | Gluten-Free | No Starch Fillers",
        features: [
            { title: "Sweet Citrus Notes", desc: "Natural linalool and aromatic oils retained via gentle milling." },
            { title: "Thickens Gravies", desc: "Provides rich consistency and natural texture to curries and soups." },
            { title: "Cooling Temperament", desc: "Balances hot spices like chilli and black pepper naturally." },
            { title: "Crisp Packaging", desc: "Nitrogen flushed seal keeps the fragrant aroma intact." },
        ],
        ayurvedicBenefits: [
            "Possesses cooling properties that balance Pitta dosha.",
            "Soothes intestinal irritation and eases digestive discomfort.",
            "Known traditionally to support urinary health and kidney detox.",
            "Promotes gentle absorption of essential nutrients.",
        ],
        nutrition: {
            energy: "298 kcal",
            carbohydrates: "54.2 g",
            protein: "12.4 g",
            fat: "17.8 g",
            activeCompound: "Linalool & Pinene",
        },
    },
    {
        id: 4,
        slug: "amchoor-powder",
        name: "Amchoor Powder",
        category: "Powdered Spices",
        weight: "100 g",
        image: spiceAmchoorPowder,
        images: [spiceAmchoorPowder, amchoorPowder],
        price: 45,
        oldPrice: 60,
        rating: 4.5,
        reviews: 76,
        badge: "",
        inStock: true,
        tagline: "Sun-Dried Raw Mango | Tangy Citrus Punch | Stone Ground to Fine Powder",
        weights: [
            { weight: "100 g", price: 45, oldPrice: 60, discount: "25% OFF" },
            { weight: "250 g", price: 95, oldPrice: 120, discount: "21% OFF", popular: true },
            { weight: "500 g", price: 180, oldPrice: 230, discount: "22% OFF" },
            { weight: "1 kg", price: 340, oldPrice: 430, discount: "21% OFF" },
        ],
        description:
            "KunjVeda Amchoor Powder is made from raw unripe mangoes that are hand-sliced, sun-dried for days under natural heat, and then stone-ground into a fine, pale beige powder. It delivers an intense tangy and mildly fruity sourness that brightens chutneys, marinades, chaats, curries, and dal without adding moisture.",
        origin: "Uttar Pradesh & Rajasthan, India",
        shelfLife: "12 Months from packaging",
        dietary: "100% Pure Vegetarian | No Artificial Souring Agents | Gluten-Free",
        features: [
            { title: "Natural Souring Agent", desc: "Replaces tamarind and lemon in dry dishes without adding extra liquid." },
            { title: "Sun-Dried Raw Mango", desc: "Traditionally dried under direct sunlight to lock in natural citric tartness." },
            { title: "Fine Powder Grind", desc: "Finely milled for even blending into spice rubs, marinades, and masalas." },
            { title: "No Acidulants Added", desc: "Pure mango sourness with zero added citric acid or synthetic preservatives." },
        ],
        ayurvedicBenefits: [
            "Stimulates appetite and aids secretion of digestive juices (Pachaka Pitta).",
            "Natural vitamin C source that boosts seasonal immunity and skin glow.",
            "Helps balance Kapha dosha with its light, dry, and astringent qualities.",
            "Traditional remedy to relieve heat strokes and excessive summer thirst.",
        ],
        nutrition: {
            energy: "314 kcal",
            carbohydrates: "72.4 g",
            protein: "2.4 g",
            fat: "1.8 g",
            activeCompound: "Natural Citric Acid & Malic Acid",
        },
    },
    {
        id: 5,
        slug: "moringa-powder",
        name: "Moringa Powder",
        category: "Herbal Powders",
        weight: "100 g",
        image: spiceMoringaPowder,
        images: [spiceMoringaPowder, moringaPowder],
        price: 95,
        oldPrice: 120,
        rating: 4.5,
        reviews: 29,
        badge: "New",
        inStock: true,
        tagline: "Organic Miracle Green | Shade-Dried Under 40°C | 90+ Nutrients",
        weights: [
            { weight: "100 g", price: 95, oldPrice: 120, discount: "21% OFF" },
            { weight: "200 g", price: 170, oldPrice: 210, discount: "19% OFF", popular: true },
            { weight: "500 g", price: 380, oldPrice: 480, discount: "21% OFF" },
            { weight: "1 kg", price: 710, oldPrice: 890, discount: "20% OFF" },
        ],
        description:
            "Known worldwide as the 'Miracle Tree', KunjVeda Moringa Powder is harvested from tender young drumstick tree leaves grown in pesticide-free Himalayan foothill farms. Shade-dried under gentle temperatures and stone-pulverized into a fine emerald powder, retaining its rich vitamins, chlorophyll, and amino acids.",
        origin: "Sub-Himalayan Foothills, Uttarakhand, India",
        shelfLife: "18 Months from packaging",
        dietary: "100% Certified Organic | Raw Vegan | Chlorophyll Rich",
        features: [
            { title: "Shade Dried Below 40°C", desc: "Protects heat-sensitive vitamins, live enzymes, and plant proteins." },
            { title: "Nutrient Powerhouse", desc: "Loaded with iron, calcium, vitamin A, potassium, and plant antioxidants." },
            { title: "Smooth Daily Blend", desc: "Easily mixes into morning green smoothies, warm water, or soups." },
            { title: "100% Pure Leaf", desc: "Zero stems, sand, or filler additives—only clean, vibrant green leaf." },
        ],
        ayurvedicBenefits: [
            "Natural energy booster that combats daily fatigue without caffeine spikes.",
            "Supports glowing skin, keratin hair synthesis, and vitality (Ojas).",
            "Helps regulate healthy blood sugar levels and cardiovascular health.",
            "High bioavailable plant calcium fortifies bone density naturally.",
        ],
        nutrition: {
            energy: "320 kcal",
            carbohydrates: "38.2 g",
            protein: "27.1 g",
            fat: "6.0 g",
            activeCompound: "Chlorophyll, Quercetin & Chlorogenic Acid",
        },
    },
    {
        id: 6,
        slug: "Amla-powder",
        name: "Amla Powder",
        category: "Herbal Powders",
        weight: "100 g",
        image: spiceAmlaPowder,
        images: [spiceAmlaPowder, amlaPowder],
        price: 95,
        oldPrice: 120,
        rating: 4.5,
        reviews: 29,
        badge: "New",
        inStock: true,
        tagline: "Organic Miracle Green | Shade-Dried Under 40°C | 90+ Nutrients",
        weights: [
            { weight: "100 g", price: 95, oldPrice: 120, discount: "21% OFF" },
            { weight: "200 g", price: 170, oldPrice: 210, discount: "19% OFF", popular: true },
            { weight: "500 g", price: 380, oldPrice: 480, discount: "21% OFF" },
            { weight: "1 kg", price: 710, oldPrice: 890, discount: "20% OFF" },
        ],
        description:
            "Known worldwide as the 'Miracle Tree', KunjVeda Moringa Powder is harvested from tender young drumstick tree leaves grown in pesticide-free Himalayan foothill farms. Shade-dried under gentle temperatures and stone-pulverized into a fine emerald powder, retaining its rich vitamins, chlorophyll, and amino acids.",
        origin: "Sub-Himalayan Foothills, Uttarakhand, India",
        shelfLife: "18 Months from packaging",
        dietary: "100% Certified Organic | Raw Vegan | Chlorophyll Rich",
        features: [
            { title: "Shade Dried Below 40°C", desc: "Protects heat-sensitive vitamins, live enzymes, and plant proteins." },
            { title: "Nutrient Powerhouse", desc: "Loaded with iron, calcium, vitamin A, potassium, and plant antioxidants." },
            { title: "Smooth Daily Blend", desc: "Easily mixes into morning green smoothies, warm water, or soups." },
            { title: "100% Pure Leaf", desc: "Zero stems, sand, or filler additives—only clean, vibrant green leaf." },
        ],
        ayurvedicBenefits: [
            "Natural energy booster that combats daily fatigue without caffeine spikes.",
            "Supports glowing skin, keratin hair synthesis, and vitality (Ojas).",
            "Helps regulate healthy blood sugar levels and cardiovascular health.",
            "High bioavailable plant calcium fortifies bone density naturally.",
        ],
        nutrition: {
            energy: "320 kcal",
            carbohydrates: "38.2 g",
            protein: "27.1 g",
            fat: "6.0 g",
            activeCompound: "Chlorophyll, Quercetin & Chlorogenic Acid",
        },
    },

];

export default products;
